class ProductCard extends HTMLElement {
  constructor() {
    super()
    this.boundHandleVariantChange = this.handleVariantChange.bind(this)
    this.labelHandlers = new Map()
  }

  connectedCallback() {
    this.productCardElement = this
    this.productId = this.getAttribute('data-product-id')
    this.sectionId = this.getAttribute('data-section-id')
    this.formElement = this.querySelector('#variant-switcher')
    this.productPriceElement = this.querySelector('[data-product-price]')
    this.productCardMediaSlider = this.querySelector('.product-card__media-slider')
    this.mediaElement = this.querySelector('.product-card__media img')
    this.quickAddVariantIdElements = this.querySelectorAll('.quick-add form [name="id"]')
    this.quickAddButtons = this.querySelectorAll('.quick-add button[data-variant-id], .quick-add form button[type="submit"]')
    this.dynamicQuickAddContainer = this.querySelector('.quick-add[data-dynamic-quick-add="true"]')
    this.variantIdElement = this.querySelector('form [name="id"]')
    this.hoverMediaElement = this.querySelector('.product-card__secondary') || this.querySelector('secondary-media')
    this.allProductCardBottomElements = this.querySelectorAll('.product-card__bottom')
    this.badgesElement = this.querySelector('.product-card__media .badges')

    if (!this.formElement) return

    this.allInputElement = this.formElement.querySelectorAll('input[type="radio"], input[type="checkbox"]')

    this.addEventListener('change', this.boundHandleVariantChange, true)

    this.allInputElement.forEach((input) => {
      const labelElement = this.formElement.querySelector('label[for="' + input.id + '"]')

      const handleUpdateColor = (event) => {
        const target = event.target
        const groupElement = target.closest('.swatches')
        const groupInputElement = groupElement.querySelectorAll('input[type="radio"], input[type="checkbox"]')
        const groupLabelElement = groupElement.querySelectorAll('label')

        groupInputElement.forEach((inputElement) => {
          inputElement.classList.remove('selected')
          inputElement.checked = false
        })

        groupLabelElement.forEach((labelElement) => {
          labelElement.classList.remove('selected')
        })

        target.classList.add('selected')

        // Use the label's htmlFor to grab the exact input paired with the
        // hovered swatch. The old `find(input => input.value === value)` fell
        // back to the FIRST matching input in DOM order, which meant that on
        // cards where we now render per-colour swatch sets (e.g. Goud + Zilver
        // stones) hovering a Zilver stone would check the Goud twin instead.
        const targetInputId = target.htmlFor || target.getAttribute('for')
        const newInputElement = (targetInputId && document.getElementById(targetInputId))
          || Array.from(this.allInputElement).find((input) => input.value === target.dataset.value)
        if (newInputElement) newInputElement.checked = true

        this.handleVariantChange()
        this.updateSwatchAvailability()
      }

      labelElement.addEventListener('mouseenter', (event) => handleUpdateColor(event) )
    })

    this.updateSwatchAvailability()

    this.allProductCardBottomElements.forEach((productCardBottomElement) => {
      window.loadSwiper().then((Swiper) => {
      this.carousel = new Swiper(productCardBottomElement.querySelector('.swatches-slider'), {
        direction: 'horizontal',
        slidesPerView: 'auto',
        breakpoints: {
          320: {
            spaceBetween: 8,
            slidesPerGroupAuto: true,
          },
          768: {
            spaceBetween: 12,
            slidesPerGroup: 4,
          },
        },
        loop: false,
        navigation: {
          nextEl: productCardBottomElement.querySelector('.swiper-button-next'),
          prevEl: productCardBottomElement.querySelector('.swiper-button-prev'),
        },
        on: {
          afterInit: (swiper) => {
            if (productCardBottomElement.querySelector('.swiper-button-next').classList.contains('swiper-button-disabled') && productCardBottomElement.querySelector('.swiper-button-prev').classList.contains('swiper-button-disabled')) {
              productCardBottomElement.querySelector('.swiper-button-next').classList.add('swiper-button-not-needed')
              productCardBottomElement.querySelector('.swiper-button-prev').classList.add('swiper-button-not-needed')
            } else {
              productCardBottomElement.querySelector('.swiper-button-next').classList.remove('swiper-button-not-needed')
              productCardBottomElement.querySelector('.swiper-button-prev').classList.remove('swiper-button-not-needed')
            }

            // Scroll to the selected variant
            const allInputElements = productCardBottomElement.querySelectorAll('.swiper-wrapper input[type="radio"]')
            const indexOfSelectedVariant = Array.from(allInputElements).findIndex((input) => input.checked)

            if (indexOfSelectedVariant !== -1 && indexOfSelectedVariant !== 0) {
              swiper.slideTo(indexOfSelectedVariant, 0, false)
            }
          }
        }
      });
      });
    });
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.boundHandleVariantChange, true)
    this.labelHandlers.forEach((handler, labelElement) => {
      labelElement.removeEventListener('mouseenter', handler)
    })
    this.labelHandlers.clear()
  }

  handleVariantChange = () => {
    if (!this.formElement) return

    const previousActiveVariantId = this.formElement.getAttribute('[name="id"]')

    this.setAttribute('aria-busy', 'true')
    this.updateOptions()
    this.getSelectedVariant()

    if (previousActiveVariantId && previousActiveVariantId === String(this.currentVariant?.id)) {
      this.setAttribute('aria-busy', 'false')
    } else if (this.currentVariant) {
      
      this.updateProductButton()
      this.previousActiveVariant = this.currentVariant
    } else {
      this.setAttribute('aria-busy', 'false')
    }
  }

  updateOptions = () => {
    const optionGroups = this.formElement
      ? Array.from(this.formElement.querySelectorAll('.swatches'))
      : []
    this.options = optionGroups.map((group) => {
      const checked = group.querySelector('input:checked')
      return checked?.value
    })
  }

  getSelectedVariant = () => {
    const variantData = this.getVariantData()

    if (!variantData || !this.options) return
    
    this.currentVariant = variantData.find((variant) =>
      variant.options?.every((option, index) => {
        return this.options[index]?.replace(' ', '').toLowerCase() == option?.replace(' ', '').toLowerCase()
      })
  )

    if (this.currentVariant && this.getHoverVariantData()) {
      const hoverVariant = this.getHoverVariantData().find(
        (variant) => variant.id === this.currentVariant.id
      )
      if (hoverVariant?.hoverImage) {
        this.currentVariant.hoverImage = hoverVariant.hoverImage
      }
    }
  }

  getVariantData = () => {
    const script = this.querySelector('script#BasicProductInfo, script[id="BasicProductInfo"]')
    if (!script?.textContent) return null

    this.variantData = this.variantData || JSON.parse(script.textContent)
    return this.variantData
  }

  getHoverVariantData = () => {
    const script = this.querySelector('script#ProductHoverImages, script[id="ProductHoverImages"]')
    if (!script?.textContent) return null

    this.extendedVariantData = this.extendedVariantData || JSON.parse(script.textContent)
    return this.extendedVariantData
  }

  getBadgeVariantData = () => {
    const script = this.querySelector('script#ProductBadgeInfo, script[id="ProductBadgeInfo"]')
    if (!script?.textContent) return null

    this.badgeVariantData = this.badgeVariantData || JSON.parse(script.textContent)
    return this.badgeVariantData
  }

  updateVariantBadges = () => {
    if (!this.currentVariant) return

    const badgeVariantData = this.getBadgeVariantData()
    if (!badgeVariantData) return

    const matchingBadgeData = badgeVariantData.find((variant) => Number(variant?.id) === Number(this.currentVariant.id))
    const badgesHtml = matchingBadgeData?.badgesHtml
    if (!badgesHtml) return

    const currentBadgesElement = this.querySelector('.product-card__media .badges')
    if (!currentBadgesElement) return

    currentBadgesElement.outerHTML = badgesHtml
    this.badgesElement = this.querySelector('.product-card__media .badges')
  }

  updateSwatchAvailability = () => {
    const variantData = this.getVariantData()
    if (!variantData || !this.formElement) return

    const allGroups = Array.from(this.formElement.querySelectorAll('.swatches'))

    const selectedValues = allGroups.map(group => {
      const checked = group.querySelector('input:checked')
      return checked?.value || null
    })

    allGroups.forEach((group, groupIndex) => {
      group.querySelectorAll('label.swatch').forEach(label => {
        const value = label.dataset.value
        const input = this.formElement.querySelector(`input[id="${label.htmlFor}"]`)

        const testOptions = selectedValues.map((sel, i) => i === groupIndex ? value : sel)

        const isAvailable = variantData.some(variant =>
          variant.available &&
          variant.options.every((opt, i) =>
            testOptions[i] == null ||
            opt?.replace(' ', '').toLowerCase() === testOptions[i]?.replace(' ', '').toLowerCase()
          )
        )

        label.classList.toggle('sold-out', !isAvailable)
        input?.classList.toggle('disabled', !isAvailable)
      })
    })
  }

  updateProductButton = () => {
    if (!this.currentVariant) return

    const allLinks = this.querySelectorAll('a[href*="/products/"]')

    allLinks.forEach((link) => {
      const newUrl = new URL(link.href)
      newUrl.searchParams.set('variant', this.currentVariant.id)
      link.setAttribute('href', newUrl.toString())
    })
    
    if (this.variantIdElement) {
      this.variantIdElement.value = this.currentVariant.id
    }

    this.quickAddVariantIdElements.forEach((variantIdInput) => {
      variantIdInput.value = this.currentVariant.id
    })

    this.quickAddButtons.forEach((button) => {
      button.dataset.variantId = String(this.currentVariant.id)
      button.disabled = !this.currentVariant.available
    })

    if (this.dynamicQuickAddContainer) {
      this.dynamicQuickAddContainer.classList.toggle('hidden', !this.currentVariant.available)
      this.dynamicQuickAddContainer.classList.toggle('flex', this.currentVariant.available)
    }

    this.updateVariantBadges()

    // Swap main image only AFTER the new one has finished decoding so the
    // previous variant image stays visible instead of flashing to blank.
    // aria-busy toggles the grey shimmer overlay (see notbranded-styling.css).
    if (this.mediaElement && this.currentVariant.featured_image) {
      const newSrc = this.currentVariant.featured_image.src
      const currentSrc = this.mediaElement.getAttribute('src')
      if (newSrc !== currentSrc) {
        this.setAttribute('aria-busy', 'true')
        const preload = new Image()
        preload.onload = () => {
          this.mediaElement.setAttribute('src', newSrc)
          this.mediaElement.setAttribute('srcset', newSrc)
          this.setAttribute('aria-busy', 'false')
        }
        preload.onerror = () => this.setAttribute('aria-busy', 'false')
        preload.src = newSrc
      } else {
        this.setAttribute('aria-busy', 'false')
      }
    } else {
      this.setAttribute('aria-busy', 'false')
    }

    if (this.currentVariant.hoverImage && this.currentVariant.hoverImage !== 'undefined') {
      if (this.hoverMediaElement) {
        // Same preload-before-swap treatment for the hover image so it doesn't
        // pop from blank while the shopper is mid-hover. Only swap once the
        // new image has decoded; leave the old one until then.
        const images = this.hoverMediaElement.querySelectorAll('img')
        const newHover = this.currentVariant.hoverImage
        const anyStale = Array.from(images).some((img) => img.getAttribute('src') !== newHover)
        if (anyStale) {
          const preload = new Image()
          preload.onload = () => {
            images.forEach((img) => {
              img.setAttribute('src', newHover)
              img.setAttribute('srcset', newHover)
              img.removeAttribute('data-src')
              img.removeAttribute('data-srcset')
            })
          }
          preload.onerror = () => {
            images.forEach((img) => {
              img.setAttribute('src', newHover)
              img.setAttribute('srcset', newHover)
            })
          }
          preload.src = newHover
        }
      } else {
        const templateElement = this.productCardElement.querySelector('template')
        const templateContentClone = templateElement?.content?.cloneNode(true)
        const newImageElement = templateContentClone?.querySelector('img')
        
        newImageElement?.setAttribute('src', this.currentVariant.hoverImage)
        newImageElement?.setAttribute('srcset', this.currentVariant.hoverImage)

        // Set the new hover image element in the HTML
        if (templateContentClone) {
          //Remove previous set hover image elements.
          this.productCardMediaSlider?.querySelectorAll('.product-card__secondary')?.forEach((element) => {
            element.remove()
          })

          this.productCardMediaSlider?.appendChild(templateContentClone)
        }

        // Add the hide on hover class to the first image element
        this.productCardMediaSlider?.querySelector('.product-card__media')?.classList?.add('hide-on-hover')
      }
    } else {
      // Remove the hide on hover class and remove the hover element.
      if (this.productCardMediaSlider?.querySelector('.product-card__secondary')) {
        this.productCardMediaSlider?.removeChild(this.productCardMediaSlider.querySelector('.product-card__secondary'))
      }
      this.productCardMediaSlider?.querySelector('.product-card__media')?.classList?.remove('hide-on-hover')
    }
  }
}

if (customElements.get('product-card') === undefined) {
  customElements.define('product-card', ProductCard)
}